import { useRouter } from 'next/router'

import { useBucket } from '@mc/experiments-react'

import { CONTEXTUAL_BROWSE_EXP_FLAG } from '../constants'

const useContextualBrowseExperiment = () => {
  const bucket = useBucket(CONTEXTUAL_BROWSE_EXP_FLAG)

  return { isVariant: !!bucket?.includes('variant') }
}

// Matches: '/classes/*', '/series/*', '/categories/*', '/subcategories/*'
// Does not match: '/', '/classes/*/chapters/*', '/categories', '/subcategories'
const REGEX_PAGES_TO_SHOW_CONCIERGE_EXPERIENCE =
  /^\/(classes\/[^/]{1,}$|series\/[^/]{1,}$|categories\/[^/]{1,}$|subcategories\/[^/]{1,}$)/

export const useContextualBrowseEnabled = () => {
  const router = useRouter()
  const { isVariant } = useContextualBrowseExperiment()

  const isContextualBrowsePages = REGEX_PAGES_TO_SHOW_CONCIERGE_EXPERIENCE.test(
    router.pathname,
  )

  return { enabled: isContextualBrowsePages && isVariant }
}
